import { render, staticRenderFns } from "./doctIndex.vue?vue&type=template&id=70c45adb&"
import script from "./doctIndex.vue?vue&type=script&lang=js&"
export * from "./doctIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports